// extracted by mini-css-extract-plugin
module.exports = {"arrowButton":"PrevArrow_arrowButton__VRU4i"};